import React, {FC} from "react";
import {Box} from "@mui/material";
import Select from "../../../../../../../../Select";
import Typography from "@mui/material/Typography";
import {useTranslation} from "react-i18next";
import styled from "@emotion/styled";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import {Tooltip} from "@material-ui/core";

const Title = styled(Typography)`
  font-weight: 600;
  font-size: 12px;
  line-height: 20px;
  color: white;
  
`

type PropsType = {
  title: string
  placeholder?: string
  list: any[]
  selected: any
  onHandleChange: (field: string, value: any, willClearField?: string | undefined) => void
  field: string
  willClearField?: string | undefined
  clearButton?: boolean
}

const SelectBlock: FC<PropsType> = ({
  title,
  placeholder = '',
  list,
  selected,
  onHandleChange,
  field,
  willClearField,
  clearButton= true,
}) => {
  const {t} = useTranslation()
  return (
   <React.Fragment>
     <Box my={2} display={'flex'} alignItems={'center'}>
       <Title>{t(title)}</Title>
     </Box>
     <Select
       placeholder={t(placeholder)}
       list={list}
       selected={selected}
       setSelected={(value) => {
         if (typeof value === 'number') {
           onHandleChange(field, Number(value) - 1, willClearField)
         } else {
           onHandleChange(field, value, willClearField)
         }
       }}
       clearButton={clearButton}
     />
   </React.Fragment>
  )
}

export default SelectBlock
